<template>
  <div>
    <v-list>
      <v-list-item two-line>
        <v-list-item-content>
          <v-skeleton-loader max-width="80px" height="36px" type="image" />
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-for="item in items" v-bind:key="item.id">
        <v-list-item-content>
          <v-skeleton-loader
            :max-width="item.maxWidth"
            max-height="17px"
            type="image"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'CustomerRecordLoading',

  data() {
    return {
      items: [
        { id: uuidv4(), maxWidth: '45%' },
        { id: uuidv4(), maxWidth: '40%' },
        { id: uuidv4(), maxWidth: '55%' },
        { id: uuidv4(), maxWidth: '45%' },
        { id: uuidv4(), maxWidth: '38%' },
        { id: uuidv4(), maxWidth: '80%' },
        { id: uuidv4(), maxWidth: '30%' },
        { id: uuidv4(), maxWidth: '40%' },
        { id: uuidv4(), maxWidth: '45%' },
      ],
    };
  },
};
</script>
